export default {
  config: {},
  gameState: {},
  forecastOdds: {},
  reverseForecastOdds: {},
  raceCardOdds: {},
  headToHeadOdds: {},
  headToHeadCombinations: [],
  reverseForecast: null,
  currentRound: null,
  offer: [],
  visualizationUrl: null,
  disabledRound: 0,
  disabledRoundBySocket: null,
  expiredBets: false,
  isonisCountryList: ['MNE'],
  userUuid: null,
  isMobile: false,
  jackpotState: undefined,
  setStateData: null,
  isStateMesageTrasfered: false,
  reverseForecastActive: false,
  nextRoundTime: null,
  inProgressRound: '',
  terminalUserData: null,
  currentScheduleRound: null,
  ticketHistoryTerminal: [],
  ticketDetailsData: null,
  loaded: false,
  activeTerminalLayout: null,
  terminalMouseCursorEnabled: true,
  allBettingDisabled: false,
  isFreeBetMode: false,
  showFreeBetModal: false,
  showFreeBetExpiredModal: false,
  appMode: null,
  thirdPartyInfo: {},
  isVisualizationLoaded: false,
  usePackageTranslations: true,
  layout: '',
  nextgenStandaloneIntegration: false,
  printedTicketsByTicketCheck: [],
};
